import { render } from "./MyAccountClient.vue?vue&type=template&id=6708622b&scoped=true"
import script from "./MyAccountClient.vue?vue&type=script&lang=js"
export * from "./MyAccountClient.vue?vue&type=script&lang=js"

import "./MyAccountClient.vue?vue&type=style&index=0&id=6708622b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6708622b"]])

export default __exports__